exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2sbqm{text-align:center}.NeKBN{width:1180px;height:360px}", ""]);

// exports
exports.locals = {
	"link": "_2sbqm",
	"img": "NeKBN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-rules-2!./node_modules/postcss-loader/lib??ref--1-rules-3!./src/components/common/Slide/index.css
// module id = 1011
// module chunks = 1 2